import { FileText } from 'lucide-react';
import { ICard } from '../types/card';
import benefitsSummary from '../assets/cardImages/benefits-summary.jpg';
import policyWording from '../assets/cardImages/policy-wording.jpg';
import policyWordingK12 from '../assets/cardImages/policy-wording-k12.jpg';
import studentPortal from '../assets/cardImages/student-portal-access.jpg';
import mentalHealthServiceGuide from '../assets/cardImages/wpo-mental-health-service-guide.jpg';
import type { IMetadataCodes } from '../types/auth/authMetadata';

export const getCardData = (
  documentCodes: IMetadataCodes | undefined
): ICard[] => {
  return [
    {
      header: 'About Your Plan - Complete K12 Plan',
      description:
        'Find details of the K12 Plan, including coverage, benefits, and eligibility. Click here to see all the essential information to help you understand this plan.',

      cardImage: policyWording,
      href: 'https://inglelewer.ca/about-your-plan-complete-k12-plan',
      isHrefExternal: true,
      icon: (
        <FileText className="h-16 w-16 p-2" stroke="#ffffff" strokeWidth={1} />
      ),
    },
    {
      header: 'About Your Plan - Complete & Complete K12 Plans',
      description:
        'See the complete outline of the key features, benefits, and coverage of both plans to help you see the plan at a glance.',

      cardImage: policyWordingK12,
      isHrefExternal: true,
      href: 'https://inglelewer.ca/about-your-plan-complete-complete-k12-plans',
      icon: (
        <FileText className="h-16 w-16 p-2" stroke="#ffffff" strokeWidth={1} />
      ),
    },
    {
      header: 'Claim Forms and Support Documentation',
      description:
        'Need to file a claim? Find all the necessary claim forms and supporting documents here. Here you will find everything required for a smooth claims process.',

      cardImage: benefitsSummary,
      isHrefExternal: true,
      href: 'https://inglelewer.ca/claim-forms-and-support-documentation/',
      icon: (
        <FileText className="h-16 w-16 p-2" stroke="#ffffff" strokeWidth={1} />
      ),
    },
    {
      header: 'WPO Mental Health Service Guide',
      description: (
        <span>
          Enter your insurance code{' '}
          <span className="font-bold">"Ingle Lewer"</span> to access services
          available with your plan.
        </span>
      ),

      cardImage: mentalHealthServiceGuide,
      isHrefExternal: true,
      href: 'pdfs/wpo-mental-health-service-guide.pdf',
      icon: (
        <FileText className="h-16 w-16 p-2" stroke="#ffffff" strokeWidth={1} />
      ),
    },
    {
      header: 'Student Portal Access PDF',
      description: (
        <>
          <span className="block">
            Mental Health Support:{' '}
            <span className="font-bold">Ingle Lewer</span>
          </span>
          <span className="block">
            Togetherall: <span className="font-bold">Lewer Canada</span>
          </span>
          <span className="block">
            Pillway: <span className="font-bold">inglehealth</span>
          </span>
          <span className="block">
            Novus Health: <span className="font-bold">00_INGLE_HEALTH</span>
          </span>

          {documentCodes?.telus && (
            <span className="block">
              Telus Health code:{' '}
              <span className="font-bold">{documentCodes?.telus}</span>
            </span>
          )}
        </>
      ),
      cardImage: studentPortal,
      isHrefExternal: true,
      href: 'pdfs/student-portal-access-guide.pdf',
      icon: (
        <FileText className="h-16 w-16 p-2" stroke="#ffffff" strokeWidth={1} />
      ),
    },
  ];
};
